<div class="card card-success">
  <div style="padding-top: 13px" class="card-body">
    <div class="row">
      <div class="col-md-1">
        <i class="fa fa-user fa-3x"></i>
      </div>
      <div class="col-md-11">
        <div class="row">
          <div style="font-size: 18px; text-decoration: underline;">
            {{ results.name }} ({{ results.dob }})
          </div>
        </div>

        <div class="row">
          <div style="font-size: 18px;">Enrollment Form Exist.</div>
        </div>
      </div>
    </div>
  </div>
</div>
